import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField,
  Button,
  Container,
  Grid,
  CircularProgress,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  Link,
} from '@material-ui/core';

import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@material-ui/icons';

import { useSnackbar } from 'notistack';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './styles';
import logoTCImg from '../../../assets/images/logo_tc.png';
import schemaAuth from './Validators';
import useAuth from '../../../contexts/Session';

function Login(props) {
  const { classes } = props;

  const location = useLocation();
  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();
  const { signIn } = useAuth();

  const [loading, setLoading] = useState(false);
  const [passwordIsVisible, setPasswordIsVisible] = useState(false);

  const [email, setEmail] = useState('');
  const [statusEmail, setStatusEmail] = useState('');

  const [password, setPassword] = useState('');
  const [statusPassword, setStatusPassword] = useState('');

  useEffect(() => {
    document.title = 'Extracto Bank | Login';
  }, []);

  const handleValidationError = (err) => {
    err.inner.forEach((element) => {
      switch (element.path) {
        case 'email':
          setStatusEmail(element.message);
          break;
        case 'password':
          setStatusPassword(element.message);
          break;
        default:
          break;
      }
    });
  };

  const login = () => {
    setLoading(true);
    schemaAuth
      .validate(
        {
          email,
          password,
        },
        { abortEarly: false },
      )
      .then(() => {
        signIn(email, password)
          .then(() => {
            const { from } = location.state || { from: { pathname: '/app' } };
            history.replace(from);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
            enqueueSnackbar(error.message, {
              variant: 'warning',
            });
          });
      })
      .catch((err) => {
        handleValidationError(err);
        setLoading(false);
        enqueueSnackbar(
          'Não foi possível realizar o login. Verifique os dados informados e tente novamente.',
          {
            variant: 'warning',
          },
        );
      });
  };

  return (
    <Container maxWidth="xs" className="lg-mg-top">
      <Grid container justify="center" alignItems="center" spacing={4}>
        <Grid item>
          <Grid container justify="center">
            <img src={logoTCImg} alt="logo" className={classes.imgLogo} />
          </Grid>
        </Grid>
        <Grid item>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              login();
            }}
          >
            <Grid item container xs={12} spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  autoFocus
                  autoComplete="off"
                  type="email"
                  label="Email"
                  value={email}
                  error={!!statusEmail}
                  helperText={statusEmail}
                  onChange={(e) => {
                    if (statusEmail) {
                      setStatusEmail('');
                    }
                    setEmail(e.target.value);
                  }}
                  FormHelperTextProps={{ error: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!statusPassword}
                >
                  <InputLabel htmlFor="password">Senha</InputLabel>
                  <OutlinedInput
                    id="password"
                    autoComplete="off"
                    label="Senha"
                    value={password}
                    onChange={(e) => {
                      if (statusPassword) {
                        setStatusPassword('');
                      }
                      setPassword(e.target.value);
                    }}
                    type={passwordIsVisible ? 'text' : 'password'}
                    endAdornment={
                      // eslint-disable-next-line react/jsx-wrap-multilines
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setPasswordIsVisible(!passwordIsVisible);
                          }}
                          edge="end"
                        >
                          {passwordIsVisible ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>{statusPassword}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid
                container
                xs={12}
                ms={12}
                sm={12}
                justify="center"
                alignItems="center"
              >
                <Link href="/informEmail" variant="subtitle2" color="primary">
                  Esqueceu sua senha?
                </Link>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  size="large"
                  endIcon={loading && <CircularProgress size={24} />}
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Login);
